import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  languageObj:any;
  language:any = "en";
  set:any = false;

  constructor(private http:HttpClient) { this.getLanguageFile(); }

  getLanguageFile() {
    this.http.get("assets/language/"+ this.language +".json")
    .subscribe(response => {
      this.languageObj = response;
    });
  }

  setLanguage(language){ 
    this.language = language; 
    this.getLanguageFile();
  }
  setup(set_up) { this.set = set_up; }
  storeLanguage() {
  }

  returnIsSetUp() { return this.set; }
  returnLanguage() { return this.language; }
  returnTranslate(label) { return this.languageObj[label]; }
}
